import IconButton from "@mui/material/IconButton";
import Bookmark from "assets/bookmark.png";
import Bookmarked from "assets/bookmarked.png";
import { setInnCode } from "components/app/App.slice";
import { updateBookmarkedInncodesAsync } from "components/features/dashboard/Dashboard.slice";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { DEFAULT_CORP_INNCODE } from "utils/CommonConstants";
import ToolTip from "./Tooltip";

interface Props {
  isBookmarked: boolean;
  item: any;
  removeCheck?: any;
  setBookmarked?: any;
  isMultiSelect?: boolean;
  bookmarked?: any;
  setSelectedOption?: any;
  selectedOption?: any;
}

export default function Bookmarkinncode(props: Props) {
  const {
    isBookmarked,
    item,
    removeCheck,
    bookmarked,
    setBookmarked,
    isMultiSelect = false,
    setSelectedOption,
    selectedOption
  } = props;
  const dispatch = useAppDispatch();
  const [isbookmark, setIsBookmarked] = useState(isBookmarked);
  const initialBookMarkInncodes = useAppSelector((state) => state.Dashboard.bookMarkInncodes);
  const bookMarkInncodes = isMultiSelect ? bookmarked : initialBookMarkInncodes;
  const isAdmin = useAppSelector((state) => state.app.isAdmin);

  function handleBookmarking() {
    delete item.isBookmarked;
    setIsBookmarked(!isbookmark);
    if (isbookmark) {
      if (removeCheck) {
        if (isMultiSelect) {
          removeCheck(item.innCode);
        } else {
          removeCheck(item.name);
        }
      }
      let finalBookmarkList = bookMarkInncodes.filter((curr: any) => curr.innCode !== item.innCode);
      if (finalBookmarkList.length === 0 && isAdmin) dispatch(setInnCode(DEFAULT_CORP_INNCODE));
      if (isMultiSelect) {
        setBookmarked(finalBookmarkList);
      } else {
        dispatch(
          updateBookmarkedInncodesAsync({
            bookmarks: finalBookmarkList
          })
        );
      }
    } else if (isMultiSelect) {
      const checkedList = selectedOption?.find((el: any) => el === item.innCode);
      if (!checkedList) setSelectedOption([...selectedOption, item.innCode]);
      setBookmarked([...bookMarkInncodes, item]);
    } else {
      dispatch(
        updateBookmarkedInncodesAsync({
          bookmarks: [...bookMarkInncodes, item]
          // shouldUpdateState: true
        })
      );
    }
  }

  return (
    <>
      <ToolTip title={isbookmark ? "Remove Bookmark" : "Bookmark this Inncode"}>
        <IconButton
          sx={{ p: 0, ml: "auto" }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleBookmarking();
          }}
        >
          <img src={isbookmark ? Bookmarked : Bookmark} alt="sample" height="23" width="23" />
        </IconButton>
      </ToolTip>
    </>
  );
}
